/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log("Expanse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co");
}

(function () {
  "use strict";

  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }

  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };

  // Marsilia Collection functionality
  theme.marsiliaCollection = function() {
    var marsiliaGrid = document.getElementById('marsilia-products-grid');
    if (!marsiliaGrid) return;

    var selectedCountEl = document.getElementById('selected-count');
    var totalQuantityEl = document.getElementById('total-quantity');
    var addToCartBtn = document.getElementById('marsilia-add-to-cart');
    var cartMessageEl = document.getElementById('cart-message');
    var discountCode = addToCartBtn ? addToCartBtn.dataset.discountCode : '3-MARSILIA';

    // Initialize quantity controls
    function initQuantityControls() {
      var quantityInputs = document.querySelectorAll('.quantity-input');
      var minusBtns = document.querySelectorAll('.quantity-btn--minus');
      var plusBtns = document.querySelectorAll('.quantity-btn--plus');

      quantityInputs.forEach(function(input) {
        input.addEventListener('change', function() {
          updateQuantity(this);
        });
        
        input.addEventListener('input', function() {
          // Allow only numbers and ensure minimum is 0
          var value = parseInt(this.value) || 0;
          if (value < 0) value = 0;
          this.value = value;
          updateQuantity(this);
        });
      });

      minusBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var input = this.parentElement.querySelector('.quantity-input');
          var currentValue = parseInt(input.value) || 0;
          if (currentValue > 0) {
            input.value = currentValue - 1;
            updateQuantity(input);
          }
        });
      });

      plusBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var input = this.parentElement.querySelector('.quantity-input');
          var currentValue = parseInt(input.value) || 0;
          input.value = currentValue + 1;
          updateQuantity(input);
        });
      });
    }

    function updateQuantity(input) {
      var productCard = input.closest('.marsilia-product-card');
      var productId = productCard.dataset.productId;
      var quantity = parseInt(input.value) || 0;
      
      // Update local storage
      var cartData = JSON.parse(localStorage.getItem('marsilia-cart') || '{}');
      if (quantity === 0) {
        delete cartData[productId];
      } else {
        cartData[productId] = {
          id: productId,
          handle: productCard.dataset.productHandle,
          quantity: quantity
        };
      }
      localStorage.setItem('marsilia-cart', JSON.stringify(cartData));
      
      updateCartSummary();
    }

    function updateCartSummary() {
      var cartData = JSON.parse(localStorage.getItem('marsilia-cart') || '{}');
      var selectedProducts = Object.keys(cartData).length;
      var totalQuantity = 0;
      
      Object.values(cartData).forEach(function(item) {
        totalQuantity += item.quantity;
      });

      if (selectedCountEl) selectedCountEl.textContent = selectedProducts;
      if (totalQuantityEl) totalQuantityEl.textContent = totalQuantity;

      // Enable/disable add to cart button
      var hasMinimumItems = totalQuantity >= 3;
      if (addToCartBtn) {
        addToCartBtn.disabled = !hasMinimumItems;
        if (hasMinimumItems) {
          addToCartBtn.classList.add('btn--primary');
          addToCartBtn.classList.remove('btn--disabled');
        } else {
          addToCartBtn.classList.remove('btn--primary');
          addToCartBtn.classList.add('btn--disabled');
        }
      }

      // Show/hide message
      if (cartMessageEl) {
        if (totalQuantity === 0) {
          cartMessageEl.textContent = '';
          cartMessageEl.style.display = 'none';
        } else if (totalQuantity < 3) {
          cartMessageEl.textContent = 'Selectați cel puțin 3 produse pentru a beneficia de reducere.';
          cartMessageEl.style.display = 'block';
          cartMessageEl.style.color = '#ff4e4e';
        } else {
          cartMessageEl.textContent = 'Reducere 15% aplicată! Selectați "Adaugă în coș" pentru a finaliza comanda.';
          cartMessageEl.style.display = 'block';
          cartMessageEl.style.color = '#28a745';
        }
      }
    }

    function getVariantId(product) {
      // If product has variants, use the first available variant ID
      if (product.variants && product.variants.length > 0) {
        return product.variants[0].id;
      }
      // If no variants, use the product ID as the variant ID
      return product.id;
    }

    function addToCart() {
      var cartData = JSON.parse(localStorage.getItem('marsilia-cart') || '{}');
      var items = Object.values(cartData);
      
      if (items.length === 0 || items.reduce((sum, item) => sum + item.quantity, 0) < 3) {
        showMessage('Selectați cel puțin 3 produse pentru a beneficia de reducere.', 'error');
        return;
      }

      // Check if gift popup is making changes to prevent conflicts
      if (window.popupMakingChanges) {
        showMessage('Așteptați finalizarea operațiunii anterioare...', 'info');
        return;
      }

      // Prepare items for cart with correct variant IDs
      var cartItems = items.map(function(item) {
        // Find the product object to get the correct variant ID
        var productCard = document.querySelector('.marsilia-product-card[data-product-id="' + item.id + '"]');
        var productHandle = productCard ? productCard.dataset.productHandle : item.handle;
        
        // For now, we'll use the product ID as variant ID
        // In a real implementation, you'd need to fetch product details to get variant IDs
        return {
          id: parseInt(item.id), // Convert to number as expected by Shopify API
          quantity: item.quantity
        };
      });

      showMessage('Se adaugă produsele în coș...', 'info');
      
      // Set flag to prevent gift popup conflicts
      window.popupMakingChanges = true;
      
      // Add items to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: cartItems })
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Eroare la adăugarea în coș: ' + response.status);
        }
        return response.json();
      })
      .then(function(data) {
        showMessage('Produse adăugate cu succes! Se aplică codul de reducere...', 'success');
        
        // Apply discount code
        return fetch('/cart', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: 'discount=' + encodeURIComponent(discountCode)
        });
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Eroare la aplicarea codului de reducere: ' + response.status);
        }
        showMessage('Produsele au fost adăugate în coș cu reducere 15%!', 'success');
        
        // Redirect to cart after 2 seconds
        setTimeout(function() {
          window.location.href = '/cart';
        }, 2000);
      })
      .catch(function(error) {
        console.error('Error:', error);
        showMessage('A apărut o eroare: ' + error.message, 'error');
      })
      .finally(function() {
        // Always clear the flag when done
        setTimeout(function() {
          window.popupMakingChanges = false;
        }, 1000);
      });
    }

    function showMessage(message, type) {
      if (cartMessageEl) {
        cartMessageEl.textContent = message;
        cartMessageEl.style.display = 'block';
        cartMessageEl.style.color = type === 'success' ? '#28a745' : '#ff4e4e';
      }
    }

    // Event listeners
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', addToCart);
    }

    // Grid view toggle buttons
    var gridViewBtns = document.querySelectorAll('.grid-view-btn');
    gridViewBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        // Remove active class from all buttons
        gridViewBtns.forEach(function(b) { b.classList.remove('is-active'); });
        
        // Add active class to clicked button
        this.classList.add('is-active');
        
        // Update grid view
        var view = this.dataset.view;
        marsiliaGrid.setAttribute('data-view', view);
      });
    });

    // Initialize
    initQuantityControls();
    updateCartSummary();
  };
  

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    // Initialize Marsilia collection functionality if on the custom page
    if (document.getElementById('marsilia-products-grid')) {
      theme.marsiliaCollection();
    }

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();
